/**
 * This funciton is creating a deep copy of an object resolving `computed` values
 * @param {*} obj An object to deep copy
 * @returns new copy
 */
export default function deepCopyComputedValue(obj) {
  const cache = new Set();
  const objVal = (obj.constructor.name === 'ComputedRefImpl') ? obj.value : obj;
  const copy = JSON.parse(JSON.stringify(objVal, (key, value) => {
    let val = value;
    /* istanbul ignore else */
    if (val && typeof val === 'object' && val !== null) {
      /* istanbul ignore else */
      if (value.constructor.name === 'ComputedRefImpl') {
        val = value.value;
      }
      // Duplicate reference found, discard key
      if (cache.has(value)) {
        val = undefined;
      } else {
        // Store value in our collection
        cache.add(value);
      }
    }
    return val;
  }));
  return copy;
}
